export default {
    edit: "Уреди",
    location: "Лоцатион + T&C",
    filter: "Филтер"
}
